import inventoryLogsApiService from '@/services/api/InventoryLogs'

const emptyFilters = {
  label: null,
  code: null
}

export default class InventoryLog {
  static api = inventoryLogsApiService
  static emptyFilters = emptyFilters
}
